

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

export class Bonuses3 extends React.Component {


    constructor(props) {
        super(props);
        this.state = { tabs: ['Nagrade', 'Jezive igre', 'Rezultati'], selectedTab: null, igre: null }


        this.setData = this.setData.bind(this);
        this.gotoTab = this.gotoTab.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.dohvatiBonusIgre = this.dohvatiBonusIgre.bind(this);


        this._games = ['grimmuerto', 'grimmuertomobile', 'fortuneteller', 'fortunetellermobile', 'wildblood', 'wildbloodmobile', 'EGT-Halloween', 'GA-WolfQuest', 'GAM_CRB', 'GAMM_CRB'];

    }




    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.gotoTab(this.state.tabs[0]);

        this.props.showLoadingFn(true);
        this.dataPromise = casino.utils.makeCancelablePromise(casino.repos.gameRepo.list().then(this.props.unpackGamesListFn));
        this.dataPromise.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        this.dataPromise.cancel();
        this.props.showLoadingFn(false);
    }

    setData(data) {
        this.setState({
            igre: data
        });
        this.props.showLoadingFn(false);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }


    renderIgra(igra) {
        return <Game key={igra.sifra} igra={igra} brands={this.props.brands} showJackpot={false} routePrefix='/promotions' />
    }
    dohvatiBonusIgre() {
        var that = this;


        return this.state.igre.filter(function (igra) {
            return that._games.indexOf(igra.sifra) != -1;
        });

    }



    render() {
        return <div >
            <MetaTags title="Bonusi - SuperSport CASINO" description="Game race bonusi u SuperSport CASINU!" />
            <Header key="header" {...this.state} {...this.props}></Header>
            <div className='white-background'>
                <div className="banner ">
                    <section className="maratonUskrsBnr2 banner--inner selected">
                        <div className="banner--content">
                            <div className="banner--bg-container">
                                <div className="banner--repeater" />
                                <div className="banner--repeater2">
                                </div>
                                <div className="banner--background" />
                                {/* <div className="banner--mask-white" /> */}
                            </div>
                            <div className="banner--foreground">
                                <div className="banner--image">
                                </div>

                                <div className="banner--text">
                                    <div className="as-inline-block center-verticaly"><span className="as-block text-white text-large   text-shadow"></span><span className="as-block text-white text-xlarge text-xbold text-shadow">USKRSNI</span><span className="as-block text-white text-xlarge text-xbold text-shadow">BONUS MARATON</span><span className="as-block text-white text-large  text-shadow">
                                        <div>SuperSport Casino poklanja 1.000 kn <b>SVAKI SAT</b>, a na sam Uskrs duplo - <b>2.000 kn.</b></div></span>
                                        <div className="margin-top"></div><div className="margin-top margin-bottom">&nbsp; </div>
                                        <div className="margin-top margin-bottom">&nbsp; </div></div></div>

                            </div>
                        </div>
                    </section>
                    {/* <TrajanjePromocije /> */}
                </div>
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile" >

                    <div style={{ height: '62px', display: 'block' }} className='mobile-hidden'></div>
                    <div className="padding-sides-medium-2 border-top-small white-background">
                        <h2 className='v4 margin-bottom-small'>Uskrsni bonus maraton</h2>

                            Svaki sat kroz blagdane <b>od četvrtka 9. travnja u 12:00 sati do ponedjeljka 13. travnja u 23:59 sati dijelimo 1000 kn</b>, a na sam Uskrs <b>dijelimo duplo - 2000 kn.</b>
                        {' '}Kvalificiraj se u prvoj polovici sata i zavrti sretni spin u drugoj polovici te odnesi nagradu.<br></br><b>Sveukupno 132 000 kn nagrada.</b>

                        <h2 className='v4 margin-bottom-small margin-top'>Kako do maraton utrke?</h2>
                            Svaka utrka se sastoji od dva dijela, prvi dio su kvalifikacije a drugi dio je izvlačenje dobitnika.
                            <br></br> <br></br>  Da bi se kvalificirali za izvlačenje, u prvoj polovici sata morate odigrati barem 20 vrtnji minimalnog uloga od jedne kune.
                            Samo tako možete biti dobitnik bonusa.
                              <br></br>    <br></br> <b>Izvlačenje dobitnika događa se u drugoj polovici sata. </b>
                        <div className='margin-bottom-small'>&nbsp;</div>



                        {/* <div className="segment v2">
                                {this.state.tabs && this.state.tabs.map((tab) =>
                                    <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                                )}
                            </div> */}
                    </div>

                    <Maraton {...this.props} hideHeader={true} extraClass="maraton2" ></Maraton>

                    <h3 className="v3 padding-sides-medium-2">Posljednji dobitnici</h3>
                    <MaratonPobjednici showLoadingFn={this.props.showLoadingFn} />



                    <div className="text-center">

                        <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/UskrsniBonusMaraton2020.pdf?c=${casino.config.guiCacheVerzija}`}>
                            <span >Pravila igre</span> <span className="icon ico-expand-outline"></span>
                        </a>
                    </div>


                </div>
            </div>
            <GameDetails {...this.props} {...this.state} routePrefix="/promotions"></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>


    }
};
